export enum UserType {
  Staff = 'Staff',
  Family = 'Family',
  Seniors = 'Member',
}

export interface IProfile {
  CustomerProfileID: string
  UserType: UserType | string
  FirstName: string
  LastName: string
  Address: string
  City: string
  State: string
  ZipCode: string
  RoomNumber: string
  LandLine: string
  LandLineOptIn: boolean
  MobilePhone: string
  MobilePhoneOptIn: boolean
  OnDemand: string
  OnDemandOptIn: boolean
  Email: string
  EmailOptIn: boolean
  SMSOptIn: boolean
  ComplianceDate1: string
  ComplianceDate2: string
  ComplianceDate3: string
  ComplianceDate4: string
  ComplianceDate5: string
  ComplianceDate6: string
  ComplianceDate7: string
  ComplianceDate8: string
  LifeDate1: string
  LifeDate2: string
  IsInactive: boolean
  InactiveStartDate: string
  InactiveEndDate: string
  Language: string
  Groups: number[]
  RelatedProfiles: string[]
  JobClassification: string
  Role: string
  BlockBeginTime: string
  BlockEndTime: string
  CustomFields: {[key: string]: string}
  CaremergeUserId: number
  ComplianceDate1MessagingEnabled: boolean
  ComplianceDate2MessagingEnabled: boolean
  ComplianceDate3MessagingEnabled : boolean
  ComplianceDate4MessagingEnabled : boolean
  ComplianceDate5MessagingEnabled: boolean
  ComplianceDate6MessagingEnabled : boolean
  ComplianceDate7MessagingEnabled : boolean
  ComplianceDate8MessagingEnabled : boolean
  LifeDate1MessagingEnabled: boolean
  LifeDate2MessagingEnabled : boolean
}

export interface IProfileExport extends Omit<IProfile, 'Groups'> {
  GroupNames: string[]
}
